import { render, staticRenderFns } from "./WorkerUnionSelect.vue?vue&type=template&id=48d31896&"
import script from "./WorkerUnionSelect.vue?vue&type=script&lang=js&"
export * from "./WorkerUnionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports